import { createContext, useContext } from 'react'

import type { Runway } from '@/api/types'

import type { QuarterCalendar } from './lib/calendar'

export interface RunwayModel {
  runway: Runway
  calendar: QuarterCalendar
  /** % of the quarter elapsed — the bar every department is measured against. */
  pacePct: number
  /** Department name for a tile code (falls back to the code). */
  deptName: (code: string) => string
}

export const RunwayContext = createContext<RunwayModel | null>(null)

export function useRunwayModel(): RunwayModel {
  const model = useContext(RunwayContext)
  if (!model) throw new Error('useRunwayModel must be used inside <RunwayContext.Provider>')
  return model
}
